export const AUTH_TYPES = {
  sms: 'sms',
  email: 'email',
};
